export default "__VITE_ASSET__B3Rdy5Jh__"